import React from 'react';
import moduleStyles from './UnderConstruction.module.scss';
export default function (props) {
  return <div className={moduleStyles.uc + ' no-print'}>Debug Mode</div>;
}
